import React, { Component } from 'react';
import Footer from '../SubComponents/Footer/Footer';
import Header from '../SubComponents/Header/Header';
import OptionList from '../SubComponents/OptionList/OptionList';
import { isModal } from '../../routesMap';

export const LocationStep = Object.freeze({
  Country: 1,
  ProvinceState: 2,
  City: 3,
  Facility: 4
});

// Props
// LocationId?: string

export default class LocationSelection extends Component {

  constructor(props) {
    super(props);
    this.inputFrozen = false;
  }

  componentDidMount() {
    console.log("[LOCATIONSELECTION] Mounted")
    this.inputFrozen = false;
    if (this.props.LocationId && this.props.LocationId.match(/^\d+$/)) {
      const id = parseInt(this.props.LocationId, 10);
      this.props.updateLocationId(id);
    }
    if (isModal) {
      this.props.fetchLocations().catch(error => { throw error; });
    }

    console.log("[LOCATIONSELECTION] postFetchLocation");
    //autofilling feature if redirected from crowd control
    let customerInfo = null;
    //check if this page was loaded via a link from account control: if it was, then update store with local storage and delete local storage
    console.log(localStorage.getItem('customerData'));
    if (localStorage.getItem('customerData') !== null) {
      customerInfo = JSON.parse(localStorage.getItem('customerData'));

      //update customer's phone number field
      customerInfo.phone = "+" + customerInfo.phone;

      this.handleCustomerInfoChange(customerInfo);
    }

    console.log("[LOCATIONSELECTION] postCustomerData");
    // localStorage.setItem('bookingData', JSON.stringify(booking_info));   //<= uncomment this to enable autocomplete via calendar when testing

    //autofilling feature if redirected from calendar
    let bookingInfo = null;
    //imitate getting local storage via calendar
    //check if this page was loaded via a link from calendar: if it was, then update store with local storage and delete local storage
    if (localStorage.getItem('bookingData') !== null) {
      bookingInfo = JSON.parse(localStorage.getItem('bookingData'));
      localStorage.removeItem('bookingData');

      this.handleBookingInfoChange(bookingInfo);
    }
      console.log("[LOCATIONSELECTION] Finished Mount")
  }

  getLocationName = location => {
    return location.displayName;
  }

  updateCountry = country => {
    if (!this.inputFrozen) this.props.updateCountry(country);
  }

  updateProvinceState = provinceState => {
    if (!this.inputFrozen) this.props.updateProvinceState(provinceState);
  }

  updateCity = city => {
    if (!this.inputFrozen) {
      // this.props.updateCity(city);
      this.props.updateCity(city).catch((error) => {
        console.error('Unable to update city: ' + error);
      });
    }
  }

  updateFacility = facility => {
    if (!this.inputFrozen) {
      this.props.updateFacility(facility).catch((error) => {
        console.error('Unable to update facility: ' + error);
      });
    }
  }

  prevStep() {
    if (this.props.step === LocationStep.Country)
      this.props.transitionBack().catch(error => { console.error(error); });
    else
      this.props.stepBack();
  }

  onClickPrev = () => {
    if (!this.inputFrozen) this.prevStep();
  }

  onCountryBack = () => {
    window.location.href = '/';
  }

  onClickNext = () => {
  }

  //FUNCTIONS FROM CHECKOUT PORTED HERE SO STORE CAN HAVE STATE OF CUSTOMER INFORMATION IMMEDIATELY
  //used for when local storage implements customer information, must dispose of local storage ASAP
  handleCustomerInfoChange = info => {
    //call each field's respective dispatch function
    this.props.setFirstName(info.first_name);
    this.props.setLastName(info.last_name);
    this.props.setEmail(info.email);
    this.props.setEmail2(info.email2);
    if (info.phone !== null && info.phone.length !== 0) {
      this.props.setPhone(info.phone);
    }
    this.props.setCustomerCardNumber(info.customer_card_number);
    this.props.setUsedLocalStorage();
  }

  handleBookingInfoChange = info => {
    this.props.setUsedBookingLocalStorage();
    this.props.selectDate(info.time);
    this.props.updateLocationId(info.location_id);
    // this.props.updateCity(info.location_name);   //<- only need updateLocationId
    //this.props.updateCity(info.location_name);    //<- only need updateLocationId
    //possibly another function for timeslot id     //<- only need updateLocationId
  }

  render() {
    switch (this.props.step) {
      case LocationStep.Country:
        return (
          <div className={'AppContainer'}>
            <Header
              header={this.props.languageObj.render.country.header}
              subHeader={this.props.languageObj.render.country.sub_header}
              classNames={'Header-bottom'}
            />
            <OptionList
              options={this.props.countryList}
              savedOption={this.props.selectedCountry}
              handleSelectOption={this.updateCountry}
            />
            <Footer
              nextName={''}
              prevName={this.props.languageObj.render.country.prev_name}
              nextDisabled={true}
              handleClickNext={this.onClickNext}
              handleClickPrev={this.onCountryBack}
              nextHidden={true}
            />
          </div>
        );
      case LocationStep.ProvinceState:
        return (
          <div className={'AppContainer'}>
            <Header
              header={this.props.selectedCountry.toLocaleUpperCase()}
              subHeader={this.props.selectedCountryCanadian ? this.props.languageObj.render.province_state.sub_header_post_true : this.props.languageObj.render.province_state.sub_header_post_false}
              classNames={'Header-bottom'}
            />
            <OptionList
              options={this.props.provinceStateList}
              savedOption={this.props.selectedProvinceState}
              handleSelectOption={this.updateProvinceState}
            />
            <Footer
              nextName={''}
              prevName={this.props.languageObj.render.province_state.prev_name}
              nextDisabled={true}
              handleClickNext={this.onClickNext}
              handleClickPrev={this.onClickPrev}
              nextHidden={true}
              isLocationSelection={true}
            />
          </div>
        );
      case LocationStep.City:
        return (
          <div className={'AppContainer'}>
            <Header
              header={this.props.selectedProvinceState.toLocaleUpperCase()}
              subHeader={this.props.languageObj.render.city.sub_header}
              classNames={'Header-bottom'}
            />
            <OptionList
              options={this.props.cityList}
              savedOption={this.props.selectedCity}
              handleSelectOption={this.updateCity}
            />
            <Footer
              nextName={''}
              prevName={this.props.languageObj.render.city.prev_name}
              nextDisabled={true}
              handleClickNext={this.onClickNext}
              handleClickPrev={this.onClickPrev}
              nextHidden={true}
              isLocationSelection={true}
            />
          </div>
        );
      case LocationStep.Facility:
        return (
          <div className={'AppContainer'}>
            <Header
              header={this.props.selectedCity.toLocaleUpperCase()}
              subHeader={this.props.languageObj.render.facility.sub_header}
              classNames={'Header-bottom'}
            />
            <OptionList
              options={this.props.facilityList}
              savedOption={this.props.selectedFacility}
              handleSelectOption={this.updateFacility}
            />
            <Footer
              nextName={''}
              prevName={this.props.languageObj.render.facility.prev_name}
              nextDisabled={true}
              handleClickNext={this.onClickNext}
              handleClickPrev={this.onClickPrev}
              nextHidden={true}
              isLocationSelection={true}
            />
          </div>
        );
      default:
        return <div>{this.props.languageObj.render.default.error}</div>;
    }
  }

}
